import * as Yup from 'yup'
import { EMAIL_REGEX, MIN_PASSWORD_LENGTH } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';


// Forgot password form validation schema.
export const FORGOTPASSWORD_STEP1_SCHEMA = Yup.object({
    email: Yup
        .string()
        .trim()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),

});

// SignIn form validation schema.
export const FORGOTPASSWORD_STEP3_SCHEMA = Yup.object({
    newpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    typepassword: Yup.string().trim().oneOf([Yup.ref('newpassword')], CommonMessages.password_match).required(CommonMessages.password_required),
});